//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return{
      type:[
        {
          value:'虚拟主机',
          name:'虚拟主机'
        },
        {
          value:'云服务器',
          name:'云服务器'
        }
      ],
      value:['虚拟主机'],
      value2:[''],
      list:[],
      vhost:[],
      vps:[],
      input:'',
      flash_url:''
    }
  },
  mounted() {
    this.getList()
  },
  watch:{
    value(val){
      if(val[0] === '虚拟主机'){
        this.list = this.vhost
        this.value2[0] = this.list[0].value
      }
      if(val[0] === '云服务器'){
        this.list = this.vps
        this.value2[0] = this.list[0].value
      }
    },
  },
  methods:{
    async getList() {
      let data = 'cmd=all_vhost_vps'
      this.$http.post('https://api.abeiyun.com/www/mianbeian.php',data).then(({data})=>{
        if(data ) {
          this.vhost = data.vhost ? data.vhost.map((item, index) => {
            return {
              value:item.id,
              name:'FTP账号：ftp'+item.id
            }
          }) : []
          this.vps = data.vps ? data.vps.map((item, index) => {
            return {
              value:item.ip,
              name:'IP：'+item.ip
            }
          }) : []
          this.list = this.vhost ? this.vhost : this.vps
          this.value = this.vhost ? ['虚拟主机'] : ['云服务器']
          this.value2[0] = this.list[0].value
        }else{
          this.$vux.alert.show({
            title: '提示信息',
            content: '服务器繁忙，请重试',
          })
        }
      })
    },
    async submit() {
      let value
      if(this.value[0] == '虚拟主机'){
        value = 'vhost'
      }
      if(this.value[0] == '云服务器'){
        value = 'vps'
      }
      let data = 'cmd=domain_add'+
        '&domain_type='+ value +
        '&id_ip='+ this.value2 +
        '&domainname='+ this.input +
        '&flash_url='+ this.flash_url
      this.$vux.loading.show({
        text: 'Loading'
      })
      let _this = this
      this.$http.post('https://api.abeiyun.com/www/mianbeian.php',data).then(({data})=>{
        if(data.response == 200 ) {
          this.$vux.loading.hide()
          this.$vux.alert.show({
            title: '提示信息',
            content: data.msg,
            onHide () {
              _this.$router.push('/user/freebeian')
            }
          })
        }else{
          this.$vux.loading.hide()
          this.$vux.alert.show({
            title: '提示信息',
            content: data.msg == 'freehost_domain' ? '注册域名请用电脑登录注册' : data.msg,
          })
        }
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/console/addfreebeian.vue